import React, { useEffect, useState } from "react";

import styles from "./index.module.css";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import sidebarItems from "./sidebar_items.json";

const Home: React.FC = () => {
  const [markdownContent, setMarkdownContent] = useState("");
  const [activeHref, setActiveHref] = useState("");
  const [showSubmenu, setShowSubmenu] = useState("");

  useEffect(() => {
    fetch(process.env.REACT_APP_PATH_HOME + "/markdown/homepage.md")
      .then((response) => response.text())
      .then((content) => {
        setMarkdownContent(content);
        console.log(content);
      })
      .catch((error) => console.error(error));
  }, []);

  function formatID(title: string) {
    return title.toLowerCase().split(" ").join("-");
  }

  return (
    <div className={styles.container}>
      <div className={styles.sidenav}>
        <h4>BTG Solutions Data Services Home</h4>
        {sidebarItems.items.map((item) => {
          return (
            <>
              <a
                className={`${
                  activeHref === item.href?.replace("#", "")
                    ? styles.active
                    : ""
                } ${item.subitems && styles.submenu}`}
                href={item.href}
                onClick={() => {
                  if (item.subitems.length !== 0) {
                    return setShowSubmenu(
                      item.href?.replace("#", "") as string
                    );
                  }
                  setActiveHref(item.href?.replace("#", "") as string);
                }}
              >
                <p>{item.name}</p>
                {item.subitems.length !== 0 && (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="chevron-right"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    {showSubmenu === item.href?.replace("#", "") ? (
                      <path
                        fill="currentColor"
                        d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
                      ></path>
                    ) : (
                      <path
                        fill="currentColor"
                        d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"
                      ></path>
                    )}
                  </svg>
                )}
              </a>
              {item.subitems.length !== 0 &&
                item.subitems.map((subitem) => {
                  return (
                    <>
                      {showSubmenu === item.href?.replace("#", "") && (
                        <a
                          className={`${
                            activeHref === subitem.href?.replace("#", "")
                              ? styles.active
                              : ""
                          } ${styles.item_submenu}`}
                          href={subitem.href}
                          onClick={() =>
                            setActiveHref(
                              subitem.href?.replace("#", "") as string
                            )
                          }
                        >
                          <p>{subitem.name}</p>
                        </a>
                      )}
                    </>
                  );
                })}
            </>
          );
        })}
        <div className={styles.logoContainer}>
          <img
            src={process.env.REACT_APP_PATH_HOME + "/btg-solutions-logo.png"}
            alt="BTG Pactual"
          />
          <p>Data Services</p>
        </div>
      </div>
      <div className={styles.mainContainer}>
        <div className={styles.wrapper}>
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            remarkPlugins={[remarkGfm]}
            children={markdownContent}
            components={{
              h2: ({ node, ...props }) => {
                return (
                  <h2 {...props} id={formatID(props.children[0] as string)} />
                );
              },
            }}
          />
        </div>
      </div>
      <a
        className={activeHref ? styles.top : styles.none}
        id="top"
        href="#readme-top"
      >
        <p>⬆</p>
      </a>
    </div>
  );
};

export default Home;
